<template>
    <nav class="navbar is-transparent">
        <div class="navbar-brand">
            <div class="navbar-item">
                <router-link to="/reg"><img src="../assets/logo.png" alt="Hjem" height="28"></router-link>
            </div>
            <div class="navbar-item" v-if="user && user.userCanEdit && user.userCanEdit.name">
               <a class="dotted" :title="tenantName">{{ user.userCanEdit.name }}</a>
            </div>
            <a role="button" class="navbar-burger burger" @click="isActive = !isActive" v-bind:class="{ 'is-active': isActive }">
                <span></span>
                <span></span>
                <span></span>
            </a>
        </div>
        <div id="topNavigation" class="navbar-menu" v-bind:class="{ 'is-active': isActive }">
            <div class="navbar-start">
                <router-link to="/reg" class="navbar-item" @click.native="isActive = !isActive" active-class="is-active">
                    {{ $t("nav.registrations") }} 
                </router-link>
                <router-link to="/approvals" class="navbar-item" @click.native="isActive = !isActive" active-class="is-active" v-if="isApprover">
                    {{ $t("nav.approval") }}
                </router-link>
                <div class="navbar-item has-dropdown is-hoverable">
                    <router-link to="/settings" class="navbar-link" @click.native="isActive = !isActive" active-class="is-active">
                        {{ $t("nav.settings") }}
                    </router-link>
                    <div class="navbar-dropdown is-boxed">
                        <router-link to="/settings/user" class="navbar-item" @click.native="isActive = !isActive" active-class="is-active">
                            {{ $t("nav.settingsUser") }}
                        </router-link>
                        <router-link to="/settings/organisation" class="navbar-item" @click.native="isActive = !isActive" active-class="is-active" v-if="$auth.isAdmin">
                            {{ $t("nav.settingsOrganisation") }}
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="navbar-end">
                <div class="navbar-item">
                    <a @click="changeLanguage('da')" v-bind:class="{'lang-select': langSelected('da')}">
                        da
                    </a>/
                    <a @click="changeLanguage('en')" v-bind:class="{'lang-select': langSelected('en')}">en</a>
                </div>
                <div to="login" class="navbar-item">
                    <p class="control">
                        <a @click="$auth.logout()" v-if="$auth.isAuthenticated()"  class="button is-danger">{{$t("nav.logout")}}</a>
                        <a @click="$auth.login()" v-else class="button is-primary">{{$t("nav.login")}}</a>
                    </p>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import firebase from '@/firebase'
import _ from 'lodash'

export default {
  name: 'TopNavigation',
  data: function() {
      return {
          isActive: false,
          isApprover: false
      }
  },
  firebase: function() { 
      const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;
      return {
          approverFor: {
              source: firebase.database().ref('/organisations/' + tenantid + '/users/' + userid + '/adminCanEdit/approverFor'),
              asObject: false,
              readyCallback() {
                  if(_.find(this.approverFor, {'.value': true})) {
                      this.isApprover = true
                  } else {
                      this.isApprover = false
                  }
              }
          },
          settings: {
              source: firebase.database().ref('/organisations/' + tenantid + '/settings/'),
              asObject: true,
          },
          user: {
              source: firebase.database().ref('/organisations/' + tenantid + '/users/' + userid),
              asObject: true,
              readyCallback() {
                if(this.user.userCanEdit.lang) {this.$i18n.locale = this.user.userCanEdit.lang}
              }
          }
      }
    },
    computed: {
        tenantName() {
            if(this.settings.companyName) {
                return this.settings.companyName
            } else {
                return false
            }
        }
    },
    methods: {
        changeLanguage(lang) {
            this.$firebaseRefs.user.child('/userCanEdit').update({'lang': lang})
            this.$i18n.locale = lang;
        },
        langSelected(lang) {
            if(lang == this.$i18n.locale) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lang-select {
    font-weight: bold
}
.dotted {
    border-bottom: 1px dashed #999;
    text-decoration: none;
}
</style>
